<template>
  <div>
    <el-header>
      <app-header :key="headerKey"></app-header>
    </el-header>
    <el-container>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-footer>
      <app-footer></app-footer>
    </el-footer>
    <time-log-form-modal></time-log-form-modal>
  </div>
</template>

<script>
  import Header from '@/components/Header';
  import Footer from '@/components/Footer';
  import TimeLogFormModal from '@/components/timeLog/TimeLogFormModal';
  import { EventBus } from '@/components/event-bus';

  export default {
    name: 'Layout',
    components: {
      appHeader: Header,
      appFooter: Footer,
      timeLogFormModal: TimeLogFormModal,
    },
    data() {
      return {
        headerKey: 0,
      };
    },
    created() {
      EventBus.$on('refresh-header', () => {
        this.headerKey += 1;
      });
    },
  };
</script>

<style lang="scss" scoped>
  .el-container{
    max-width: 1440px;
    padding: 100px 0 0;
    margin: 0 auto;
    .el-main{
      padding: 0 30px;
    }
  }
  .el-footer{
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/templates/Layout.vue